module.exports = __webpack_public_path__ + "img/upside_down_sign.6e782d65.jpg";